




















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class TextareaTooltip extends Vue {
  @Prop() private label!: any;
  @Prop() private value!: string;
}
